<template>
<div style="float: left; width: 100%;">

    <div class="list-group">
        <div class="list-group-item log-head">
            <div class="row">
                <div class="col-md-20">
                    Partner
                </div>
                <div class="col-md-6">
                    Startdatum
                </div>
                <div class="col-md-6">
                    Slutdatum
                </div>
                 <div class="col-md-14">
                    Kommentar
                </div>
            </div>
        </div>

        <div class="list-group-item log-item" v-for="entry in address.log_clinics">
            <div class="row" :class="{ 'bold-row' : !entry.next_address_entry }">
                <div class="col-md-20">
                    <a :href="'/clinics/'+entry.clinic.id">{{ entry.clinic.name_person }}</a> <div class="badge badge-primary" v-if="!entry.next_address_entry">Kopplad till adress</div>
                </div>
                <div class="col-md-6">
                    {{ entry.date.substr(0, 10) }}
                </div>
                <div class="col-md-6">
                    <span v-if="entry.next_address_entry">
                        {{ entry.next_address_entry.date.substr(0, 10) }}
                    </span>
                </div>
                <div class="col-md-18">
                    <span v-if="entry.next_address_entry && entry.next_address_entry.address_id">
                        Bytte till <a :href="'/addresses/'+entry.next_address_entry.address.id">{{ entry.next_address_entry.address.title }}</a>
                    </span>
                    <span v-if="entry.next_address_entry && !entry.next_address_entry.address_id">
                        Slutade som partner
                    </span>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>

    export default {

        props: {

            address: {
                required: true,
            }

        },

        data ()
        {
            return {

            }
        }

    }

</script>
